import moment from "moment";
import React, { useState, useEffect } from "react";
import {
  capitalizeFirstLetters,
  isNumber,
  numberWithCommas,
} from "../../utils/customFunction";
import { useHistory } from "react-router-dom";
import { Container, Row, Col, FormGroup, Label, Input } from "reactstrap";
import { Modal } from "react-bootstrap";
import { IoDocumentsOutline } from "react-icons/io5";
import CardColComponent from "../genericCardComponent/CardColComponent";
import { getFundByAmc } from "../../stores/services/funds.service";
import ReactTooltip from "react-tooltip";
import { RiCheckboxMultipleLine, RiPrinterLine } from "react-icons/ri";
import { getLedger } from "../../stores/services/transactions.service";
import { getAllBankTemplates } from "../../stores/services/template.service";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { vpsTxnStatus } from "../../utils/ui_data";

function TransactionTable({
  transactions,
  CapTxnType,
  historyPath = "",
  type = "",
  pageName = "",
  setViewTxnModal = "",
  setData = "",
  setTrxHistory = "",
  bankName = "",
  removeTxnFromBulk = "",
  addTxnForBulk = "",
  checkBoolean = "",
  userDepartment = "",
  setViewChildrensListing = "",
  hasChild = "",
}: {
  transactions: any;
  CapTxnType: any;
  historyPath?: any;
  type?: any;
  pageName?: any;
  setViewTxnModal?: any;
  setData?: any;
  setTrxHistory?: any;
  bankName?: any;
  removeTxnFromBulk?: any;
  addTxnForBulk?: any;
  checkBoolean?: any;
  userDepartment?: any;
  setViewChildrensListing?: any;
  hasChild?: any;
}) {
  const history = useHistory();
  const role_name = sessionStorage.getItem("role") || "";
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const authorizedTxn = window?.location?.href;

  const [fundNames, setFundNames] = useState({});

  useEffect(() => {
    const fetchAllFundsAndMapNames = async () => {
      try {
        const response = await getFundByAmc(email, amc_code, "");
        const allFunds = response?.data?.data || [];

        const fundNamesMap = {};
        allFunds.forEach((fund) => {
          if (fund?.symbol_code && fund?.fund_name) {
            fundNamesMap[fund?.symbol_code] = fund?.fund_name;
          }
        });

        const finalFundNamesMap = {};
        transactions?.forEach((transaction) => {
          if (transaction?.fund_code) {
            finalFundNamesMap[transaction.fund_code] =
              fundNamesMap[transaction.fund_code];
          }
        });

        setFundNames(finalFundNamesMap);
      } catch (error) {
        console.error("Failed to fetch funds:", error);
        const fallbackMap = {};
        transactions.forEach((transaction) => {
          if (transaction.fund_code) {
            fallbackMap[transaction.fund_code] = "";
          }
        });
        setFundNames(fallbackMap);
      }
    };

    if (transactions.length > 0) {
      fetchAllFundsAndMapNames();
    }
  }, [transactions, email, amc_code]);

  const formattedTransactions = transactions.map((transaction: any) => {
    const executionDate = moment(transaction?.settlement_date).format(
      "DD-MM-YYYY",
    );
    const instructionDate = moment(transaction.instruction_date).format(
      "DD-MM-YYYY",
    );

    let transactionType: any = "N/A";
    if (transaction.txnr_type) {
      // a reversal mirror of a type outside MIRRORED_REVERSAL_TYPES carries the synthetic
      // "reversal" type, so its txn_title ("Reversal of Fee Payment") is the useful label
      transactionType =
        (transaction.txnr_type === "reversal" && transaction.txn_title) ||
        CapTxnType(transaction.txnr_type) ||
        transaction.txn_title ||
        capitalizeFirstLetters(transaction.txnr_type.replace(/_/g, " "));
      if (transaction.detail?.includes("Reversed")) {
        transactionType += " (Reversed)";
      }
    }

    const unitholderName =
      transaction?.unitholder_name?.length > 10
        ? transaction?.unitholder_name?.slice(0, 10) + "..."
        : transaction?.unitholder_name;

    // reversal txns carry negative amounts - show them instead of collapsing to 0
    const toAmount = (value: any) =>
      numberWithCommas(
        isNaN(parseFloat(value)) ? 0 : parseFloat(value).toFixed(4),
      );
    const netAmount = toAmount(transaction.net_amount);
    const grossAmount = toAmount(transaction.gross_amount);

    const bankName = transaction?.bank || transaction?.counter_bank;
    const accountNumber =
      (transaction?.account_number?.length > 14
        ? transaction?.account_number?.slice(0, 14) + "..."
        : transaction?.account_number) ||
      (transaction?.counter_account_number?.length > 14
        ? transaction?.counter_account_number?.slice(0, 14) + "..."
        : transaction?.counter_account_number);

    const createdAtDate = moment(transaction.created_at).format("DD-MM-YYYY");
    const createdBy = transaction.created_by.split("@")[0];

    let statusDate = "";
    const lastTxnHistory =
      transaction?.txn_history?.[transaction?.txn_history?.length - 1];
    if (lastTxnHistory) {
      if (
        lastTxnHistory.created_at !== "" &&
        lastTxnHistory.action === "CREATED"
      ) {
        statusDate = moment(lastTxnHistory.created_at).format("DD-MM-YYYY");
      } else if (lastTxnHistory.updated_at || lastTxnHistory.created_at) {
        statusDate = moment(
          lastTxnHistory.updated_at || lastTxnHistory.created_at,
        ).format("DD-MM-YYYY");
      }
    }

    const statusColor =
      transaction?.txn_status === "COMPLETED" ? "#21b55c" : "";

    return {
      ...transaction,
      formattedExecutionDate: executionDate,
      formattedInstructionDate: instructionDate,
      displayTransactionType: transactionType,
      displayUnitholderName: unitholderName,
      displayNetAmount: netAmount,
      displayGrossAmount: grossAmount,
      displayBankName: bankName,
      displayAccountNumber: accountNumber,
      displayCreatedAtDate: createdAtDate,
      displayCreatedBy: createdBy,
      displayStatusDate: statusDate,
      displayStatusColor: statusColor,
    };
  });

  const [ledgerData, setLedgerData] = useState<any>([]);

  const [viewLedgers, SetViewLedgers] = useState(false);
  const [ledgerLoading, setledgerLoading] = useState(false);

  return (
    <>
      <div className="table-responsive">
        <table className="table mt-2">
          <thead>
            <tr>
              {pageName === "authorizerTransaction" && <th>Select</th>}
              <th>Date</th>
              <th>Fund</th>
              <th>Transaction</th>
              <th>Investor</th>
              <th>Units</th>
              <th>Amount</th>
              <th>Bank</th>
              <th>Created</th>
              <th>Status</th>
              <th>Act</th>
            </tr>
          </thead>
          <tbody>
            {formattedTransactions.map((transaction: any, index: number) => (
              <tr key={index}>
                {pageName === "authorizerTransaction" && (
                  <td
                    onClick={() => {
                      if (
                        userDepartment === "ADMIN" ||
                        email !== transaction.created_by
                      ) {
                        if (
                          checkBoolean(
                            transaction.txn_id.replace("TXN_", ""),
                          ) === false
                        ) {
                          addTxnForBulk(transaction);
                        } else {
                          removeTxnFromBulk(transaction);
                        }
                      }
                    }}
                  >
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={checkBoolean(
                            transaction.txn_id.replace("TXN_", ""),
                          )}
                          disabled={
                            userDepartment !== "ADMIN" &&
                            email === transaction.created_by
                          }
                          onChange={() => {
                            if (
                              userDepartment === "ADMIN" ||
                              email !== transaction.created_by
                            ) {
                              if (
                                checkBoolean(
                                  transaction.txn_id.replace("TXN_", ""),
                                ) === false
                              ) {
                                addTxnForBulk(transaction);
                              } else {
                                removeTxnFromBulk(transaction);
                              }
                            }
                          }}
                        />
                        <span className="form-check-sign" />
                      </Label>
                    </FormGroup>
                  </td>
                )}
                <td>
                  {transaction.formattedExecutionDate}
                  <br />
                  <span className="sub-content">
                    Entry {transaction.formattedInstructionDate}
                  </span>
                </td>
                <td>
                  {transaction.fund_code}
                  <br />
                  <span
                    className="sub-content"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={fundNames[transaction.fund_code]}
                  >
                    {(fundNames[transaction.fund_code]?.length > 10
                      ? fundNames[transaction.fund_code]?.slice(0, 10) + "..."
                      : fundNames[transaction.fund_code]) || "Loading..."}
                  </span>
                </td>
                <td>
                  {transaction.displayTransactionType}
                  <br />
                  <span className="sub-content">
                    {transaction.txn_id.replace("TXN_", "")}
                  </span>
                </td>
                <td>
                  {transaction.folio_no?.replace(
                    `${transaction?.amc_code}-`,
                    "",
                  )}
                  <br />
                  <span
                    className="sub-content"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={transaction?.unitholder_name}
                  >
                    {transaction.displayUnitholderName}
                  </span>
                </td>
                <td>
                  <CardColComponent
                    subTitle={parseFloat(transaction?.units).toFixed(4)}
                    amount={true}
                    forTxn={true}
                    simple={true}
                  />
                  <span className="sub-content">@ {transaction?.nav || 0}</span>
                </td>
                <td className="text-left pr-3">
                  <CardColComponent
                    subTitle={transaction?.displayNetAmount}
                    simple={true}
                    amount={true}
                    forTxn={true}
                  />
                  <span className="sub-content">
                    <CardColComponent
                      subTitle={transaction?.displayGrossAmount}
                      simple={true}
                      amount={true}
                      forTxn={true}
                    />
                  </span>
                </td>
                <td>
                  {transaction.displayBankName}
                  <br />
                  <span
                    className="sub-content"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={
                      transaction?.account_number ||
                      transaction?.counter_account_number
                    }
                  >
                    {transaction.displayAccountNumber}
                  </span>
                </td>
                <td>
                  {transaction.displayCreatedAtDate} <br />
                  <span className="sub-content">
                    {transaction.displayCreatedBy}
                  </span>
                </td>
                <td>
                  <span style={{ color: transaction.displayStatusColor }}>
                    {transaction?.txn_status}
                  </span>
                  <br />
                  <span className="sub-content">
                    {transaction.displayStatusDate}
                  </span>
                </td>
                <td className=" ">
                  <div className="multi-icons pointer">
                    <button
                      type="button"
                      className="btn-icon btn-link like btn btn-info btn-sm"
                      onClick={() => {
                        if (transaction.txnr_type === "fundprofit") {
                          history.push(
                            `/admin/view-profit-txn/${transaction.txn_id}`,
                          );
                          return;
                        }
                        if (
                          [
                            "investment",
                            "withdrawal",
                            "changeofallocation",
                          ].includes(transaction?.txnr_type)
                        ) {
                          history.push(
                            `/admin/view-vps-transactions/${transaction?._id}`,
                          );
                          return;
                        }
                        if (pageName === "pendingTransaction") {
                          let bankname = bankName(
                            transaction?.bank?.toString(),
                          );
                          transaction.bank = bankname;
                          let counterbankname = bankName(
                            transaction?.counter_bank?.toString(),
                          );
                          transaction.counter_bank = counterbankname;
                          setTrxHistory(transaction?.txn_history);
                          setData(transaction);
                          setViewTxnModal(true);
                        }
                        if (type !== "" && historyPath !== "") {
                          sessionStorage.setItem(
                            type,
                            JSON.stringify(transaction),
                          );
                          history.replace(historyPath);
                        }
                      }}
                    >
                      <i className="fa fa-eye"></i>
                    </button>

                    {vpsTxnStatus.includes(transaction.txnr_type) &&
                      transaction.txn_status === "COMPLETED" && (
                        <button
                          type="button"
                          data-tip={"View Ledgers"}
                          className="btn-icon btn-link like btn btn-primary btn-sm  mt-minus6"
                          onClick={() => {
                            const getLederByTxnId = async () => {
                              try {
                                setledgerLoading(true);
                                const response = await getLedger(
                                  email,
                                  transaction.txn_id.replace("TXN_", ""),
                                );

                                // Properly reset and populate ledger data
                                const newLedgerData: any[] = [];
                                const array = Object.entries(
                                  response.data.data,
                                );

                                array.forEach(([key, value]) => {
                                  const data: any = value;
                                  const record: any = {
                                    Record: {
                                      ...data,
                                      ledger_id: data._id,
                                    },
                                  };
                                  newLedgerData.push(record);
                                });

                                setLedgerData(newLedgerData);
                                SetViewLedgers(true);
                                setledgerLoading(false);
                              } catch (err) {
                                console.error("Error fetching ledgers:", err);
                                setledgerLoading(false);
                              }
                            };
                            getLederByTxnId();
                          }}
                        >
                          <i className="fa fa-clipboard-list"></i>
                        </button>
                      )}

                    {!hasChild &&
                      transaction?.has_sub_transaction &&
                      !authorizedTxn?.includes("authorizer") && (
                        <button
                          type="button"
                          className="btn-icon btn-link like btn btn-info btn-sm"
                          onClick={() => {
                            setData(transaction);
                            setViewTxnModal(true);
                            setViewChildrensListing(true);
                          }}
                        >
                          <IoDocumentsOutline />
                        </button>
                      )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal
        className=""
        size="xl"
        show={viewLedgers}
        onHide={() => SetViewLedgers(false)}
      >
        <div className="modal-header ">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              SetViewLedgers(false);
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up"> Ledgers </h6>
        </div>

        <div className="modal-body">
          <Row>
            <Col md="12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Ledgers</h4>
                </div>
                <div className="card-body">
                  {ledgerLoading ? (
                    <div className="d-flex justify-content-center my-5">
                      <i className="fa fa-spinner fa-spin fa-3x"></i>
                    </div>
                  ) : ledgerData.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Ledger ID</th>
                            <th>Ledger Code</th>
                            <th>Description</th>
                            <th>Fund Account</th>
                            <th>Debit Amount</th>
                            <th>Credit Amount</th>
                            <th>Counter Account</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ledgerData.map((item: any, index: string) => {
                            return (
                              <tr key={index}>
                                <td>
                                  {item?.Record?.ledger_id.replace(
                                    "ACCOUNTLEDGER_",
                                    "",
                                  )}
                                </td>
                                <td>{item?.Record?.gl_code || "-"}</td>
                                <td>
                                  {item?.Record?.description.split("-")[0]}
                                </td>
                                <td>
                                  {item?.Record?.account_number}
                                  <br />{" "}
                                  <small>
                                    <span className="text-muted">
                                      {" "}
                                      {item?.Record?.account_title}{" "}
                                    </span>
                                  </small>
                                </td>
                                <td>
                                  {numberWithCommas(
                                    parseFloat(
                                      isNumber(item?.Record?.debit_amount),
                                    ),
                                  )}
                                </td>
                                <td>
                                  {numberWithCommas(
                                    parseFloat(
                                      isNumber(item?.Record?.credit_amount),
                                    ),
                                  )}
                                </td>
                                <td>
                                  {item.Record.counter_account_number}
                                  <br />{" "}
                                  <small>
                                    <span className="text-muted">
                                      {" "}
                                      {item?.Record?.counter_account_title}{" "}
                                    </span>
                                  </small>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center my-5">
                      <p>No ledger data available</p>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
}

export default TransactionTable;
